<template>
  <div class="algodep-footer">
    <div class="fotter-box">
      <div class="title">
        <img src="../assets/fotter.png" alt="">
        <p>ALGODEP</p>
      </div>
      <div class="menuList">
        <div class="item">
          <img src="../assets/tel.png" alt="">
          <div>
            <p>电话</p>
            <span>66573407</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/email.png" alt="">
          <div>
            <p>郵箱</p>
            <span>seasonalveget@gmail.com</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/address.png" alt="">
          <div>
            <p>地址</p>
            <span>
              Rm 101A 1/F GENPLUS
              FTY BLDG 56 HOI YUEN RD Kwun
              Tong Hong Kong</span>
          </div>
        </div>
      </div>
    </div>
    <div class="fotter-info">
      Copyright © 2024.Company name All rights reserved
    </div>
  </div>
</template>
<script>
export default {
  name: "fotter",
  data() {
    return {
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "aboutUs" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "projects" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.algodep-footer {
  font-size: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #333333;
  background: #121A45;
  text-align: center;

  .fotter-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 40px 360px;
    border-bottom: 1px solid #606060;

    .title {
      display: flex;
      align-items: center;

      img {
        margin-right: 16px;
        width: 40px;
        height: 32px;
      }

      p {
        font-size: 24px;
        font-family: Krungthep;
        color: #FFFFFF;
      }
    }

    .menuList {
      display: flex;
      align-items: center;

      .item {
        margin-right: 40px;
        display: flex;
        align-items: center;
        text-align: left;

        img {
          margin-right: 16px;
          width: 45px;
          height: 45px;
        }

        p {
          margin-bottom: 10px;
          font-size: 18px;
          color: rgba(255, 255, 255, 0.60);
        }

        span {
          font-size: 18px;
          color: rgba(255, 255, 255, 1);
        }
      }

      .item:nth-child(3) {
        margin-right: 0;
      }
    }
  }

  .fotter-info {
    padding: 28px 0;
    font-size: 14px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    color: #FFFFFF;
  }
}
</style>
